package com.essntl.core.whatsapp.domain.models

import kotlinx.serialization.Serializable

@Serializable
data class SendContact(
    val to: String,
)
